<!-- Botón crear formulario -->
<div style="text-align: right;">
  <button pButton type="button" icon="pi pi-plus"
          class="p-button-rounded boton-rosado"
          [routerLink]="['/formulario']">
  </button>
</div>

<!-- Estrategias -->
<p-accordion>
  <p-accordionTab *ngFor="let estrategia of agrupados | keyvalue"
                  header="{{ estrategia.key }}">

    <!-- Proyectos -->
    <p-accordion [activeIndex]="0">
      <p-accordionTab *ngFor="let nombre of estrategia.value | keyvalue"
                      header="{{ nombre.key }}">

        <!-- Descripción del proyecto -->
        {{ nombre.value[0].Descripcion }}

        <!-- Botones (Excel / Power BI) -->
        <div class="contenedor-boton">
          <!-- Excel -->
          <button *ngIf="nombre.value[0].Proyecto"
                  pButton type="button" icon="pi pi-file-excel"
                  class="p-button-rounded boton-rosado"
                  pTooltip="Reporte Excel" tooltipPosition="top"
                  (click)="abrirProyecto(nombre)">
          </button>

          <!-- Power BI -->
          <a *ngIf="nombre.value[0].PBI"
             pButton type="button" icon="pi pi-chart-bar"
             class="p-button-rounded boton-rosado"
             pTooltip="Reporte Power BI" tooltipPosition="top"
             [href]="nombre.value[0].PBI" target="_blank">
          </a>
        </div>

        <!-- Tabla de módulos / formularios -->
        <p-table [value]="agrupados[estrategia.key][nombre.key]"
                 [tableStyle]="{ 'min-width': '50rem' }"
                 [rowHover]="true">

          <!-- Encabezado -->
          <ng-template pTemplate="header">
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Agregar Encuestados</th>
              <th>Fecha</th>
            </tr>
          </ng-template>

          <!-- Filas -->
          <ng-template pTemplate="body" let-formulario>
            <tr (click)="navigateToFormulario(formulario._id)" pSelectableRow>
              <td>{{ formulario.Definicion?.title }}</td>
              <td>{{ formulario.Definicion?.description }}</td>
              <td>{{ formulario.AgregarSujeto ? 'Sí' : 'No' }}</td>
              <td>{{ formulario.FechaCrea | date:'short' }}</td>
            </tr>
          </ng-template>

        </p-table>
      </p-accordionTab>
    </p-accordion>

  </p-accordionTab>
</p-accordion>
